console.log('Eric - Selluxe Dev');

// window.addEventListener('DOMContentLoaded', () => {
//   const prisGTE = document.querySelector('#Mobile-Filter-Prijs-GTE');
//   const prisLTE = document.querySelector('#Mobile-Filter-Prijs-LTE');

//   if(prisGTE && prisLTE) {
//     prisGTE.addEventListener('change', (e) => {
//       if(prisGTE.value === '') {
//         e.preventDefault();
//         console.log('prevented!');
//       }
//     });
    
//     prisLTE.addEventListener('change', (e) => {
//       if(prisLTE.value === '') {
//         e.preventDefault();
//         console.log('prevented!');
//       }
//     });
//   }
// })

// window.addEventListener('click', (e) => {
//   if(e.target.classList.contains('mobile-facets__clear')) {
//     document.querySelector('body').classList.remove('overflow-hidden-mobile');
//   }
// });

